<template>
    <div>
        <rkm-modal
            :extra-large="showCalendar"
            persistent
            ref="RkmModal"
            title="Cadastro de agendamento"
        >
            <rkm-form
                v-if="model"
                ref="RkmFormCadastro"
                show-legend
            >
                <rkm-row>
                    <rkm-col :cols="showCalendar ? 5 : 12">
                        <rkm-row v-if="regulacaoSolicitacao && regulacaoSolicitacao.numero">
                            <rkm-col>
                                <rkm-form-input
                                    :value="regulacaoSolicitacao.numero"
                                    disabled
                                    label="Protocolo de fechamento"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-select
                                    :disabled="disableFilters || isFromRegulacao"
                                    :options="form.unidades"
                                    :validations="validations.unidade"
                                    @change="handleUnidadeChange"
                                    label="Unidade"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="model.unidadeId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-select
                                    :disabled="disableFilters || isFromRegulacao"
                                    :options="form.infraestruturas"
                                    :validations="validations.infraestrutura"
                                    @change="handleInfraestruturaChange"
                                    label="Local de atendimento"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.infraestruturaId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-select
                                    :disabled="disableFilters || isFromRegulacao"
                                    :options="form.ocupacoes"
                                    :validations="validations.ocupacao"
                                    @change="handleOcupacaoChange"
                                    label="CBO"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="model.ocupacaoId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-select
                                    :disabled="disableFilters || isFromRegulacao"
                                    :options="form.especialidades"
                                    :validations="validations.especialidade"
                                    @change="handleEspecialidadeChange"
                                    label="Especialidade"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.especialidadeId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-form-select
                                    :disabled="disableFilters"
                                    :options="form.usuarios"
                                    :validations="validations.usuario"
                                    @change="handleUsuarioChange"
                                    label="Profissional"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.usuarioId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>

                    <rkm-col
                        v-if="showCalendar"
                        class="mt-1"
                        cols="7"
                    >
                        <rkm-calendar
                            :items="eventosCalendario.concat(datasBloqueadas).concat(datasComAgendamentoAmbulatorio).concat(datas)"
                            @click="handleCalendarioClick"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <template v-slot:footer="{cancel}">
                <rkm-button @click="cancel">
                    Fechar
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalSupervisorAgendamento
            @authorized="authorizedSupervisorAgendamento"
            @canceled="canceledSupervisorAgendamento"
            ref="ModalSupervisorAgendamento"
        />

        <ModalSupervisorJornada
            @authorized="authorizedSupervisorJornada"
            @canceled="canceledSupervisorJornada"
            ref="ModalSupervisorJornada"
        />

        <ModalHorario
            v-if="model"
            :data="{form, model}"
            :paciente-id="pacienteId"
            :regulacao-solicitacao="regulacaoSolicitacao"
            @hided="$refs.RkmModal.hide()"
            @saved="handleSaved"
            ref="ModalHorario"
        />
    </div>
</template>

<script>
// Components.
import ModalHorario from './components/horario/Modal'
import ModalSupervisorAgendamento from '@/components/ambulatorio/components/supervisor/Modal'
import ModalSupervisorJornada from '@/components/ambulatorio/components/supervisor/Modal'

// Enums.
import agendamentoStatus from '@/enums/ambulatorio/agendamentoStatus'

// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        ModalHorario,
        ModalSupervisorAgendamento,
        ModalSupervisorJornada,
    },
    computed: {
        feriados() {
            return this.form.feriados.map(feriado => {

                return {
                    dates: this.others.moment(feriado.data, 'DD/MM/YYYY'),
                    highlight: 'yellow',
                    popover: feriado.observacao,
                    title: feriado.tipoDescricao,
                }
            })
        },

        situacao(){
            return this.form.datasComSituacao.map(situacao => {
                return {
                    dates: this.others.moment(situacao.data, 'DD/MM/YYYY'),
                    highlight: 'yellow',
                    popover:situacao.situacaoNome,
                    title:situacao.situacaoNome
                }
            })
        },
        eventosCalendario(){
            return [
                ...this.feriados,
                ...this.situacao
            ]
        },
        datasBloqueadas() {
            return this.form.datasBloqueadas.map(dataBloqueada => {
                return {
                    dates: this.others.moment(dataBloqueada, 'DD/MM/YYYY'),
                    highlight: 'red',
                    title: 'Bloqueada',
                }
            })
        },
        datasComAgendamentoAmbulatorio() {
            const especialidade = this.form.especialidades.find(especialidade => especialidade.id === this.model.especialidadeId)

            if (especialidade && ((especialidade.tratamento === false && especialidade.permiteAgendamentoMesmoDia === false) || (especialidade.tratamento === true && especialidade.permiteAgendamentoMesmoDia === false))) {

                return this.form.datasComAgendamento.ambulatorio
                    .filter(dataComAgendamentoAmbulatorio => dataComAgendamentoAmbulatorio.especialidadeId === this.model.especialidadeId)
                    .map(dataComAgendamentoAmbulatorio => {
                        return {
                            dates: this.others.moment(dataComAgendamentoAmbulatorio.data, 'DD/MM/YYYY'),
                            highlight: 'blue',
                            popover: `O paciente já possui um agendamento nesta data para o horário ${dataComAgendamentoAmbulatorio.horario}`,
                            title: 'Agendado',
                        }
                    })
            }

            return []
        },
        datas() {
            return this.form.datas.map(data => {
                return {
                    dates: this.others.moment(data.data, 'DD/MM/YYYY'),
                    highlight: data.quantidadeAgendada >= data.quantidadeTotal ? 'red' : 'green',
                    title: `${data.quantidadeAgendada} / ${data.quantidadeTotal}`,
                }
            })
        },
        validations() {
            return {
                unidade: {required: true},
                infraestrutura: {required: true},
                usuario: {required: true},
                ocupacao: {required: true},
                especialidade: {required: true},
            }
        },
        isFromRegulacao() {
            return !!this.regulacaoSolicitacao
        }
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('ambulatorio.agendamento'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
        }
    },
    data: () => ({
        additionals: null,
        agendamentoId: null,
        enums: {agendamentoStatus},
        form: null,
        model: null,
        others: {moment},
        showCalendar: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        ...mapGetters(['getLotacao']),
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.model.infraestruturaId = null
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.showCalendar = false

            if (value === null) return

            this.getInfraestruturas(value)
        },
        handleInfraestruturaChange(value) {
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.showCalendar = false

            if (value === null) return

            this.getOcupacoes(value)
        },
        handleOcupacaoChange(value) {
            this.form.especialidades = []
            this.form.usuarios = []
            this.model.especialidadeId = null
            this.model.usuarioId = null
            this.showCalendar = false

            if (value === null) return

            this.getEspecialidades(this.model.infraestruturaId, value)
        },
        handleEspecialidadeChange(value) {
            this.form.usuarios = []
            this.model.usuarioId = null
            this.showCalendar = false

            const especialidade = this.form.especialidades.find(especialidade => especialidade.id === value)

            if (value === null) return

            if (especialidade.isRegulado == true && this.isFromRegulacao == false) {

                        let message = 'A especialidade selecionada é regulada, para prosseguir é necessário a senha de um supervisor. Deseja continuar?'

                        this.showConfirmation(
                            message,
                            async () => {

                                await this.$nextTick()
                                this.$refs.ModalSupervisorAgendamento.open({ infraestruturaId: this.model.infraestruturaId, lotacaoInfraestruturaId: this.getLotacao().infraestruturaId })
                            },
                            async () => {
                                this.model.especialidadeId = null
                            }
                        )
                        return
            }

            if (especialidade.tratamento === false) {
                this.getAgendamentos(this.model.especialidadeId)
            } else {
                this.getUnidadePaciente(this.model.infraestruturaId, value)
            }
        },
        handleUsuarioChange(value) {
            this.showCalendar = false

            if (value === null) return

            this.getSugestao(this.model.infraestruturaId, this.model.ocupacaoId, this.model.especialidadeId, value)
        },
        handleCalendarioClick(value) {
            const especialidade = this.form.especialidades.find(especialidade => especialidade.id === this.model.especialidadeId)

            let data = this.form.datas
                .filter(data => !this.form.feriados.find(feriado => feriado.data === data.data))
                .filter(data => !this.form.datasBloqueadas.find(dataBloqueada => dataBloqueada === data.data))

            if (especialidade.permiteAgendamentoMesmoDia === false) {
                data = data.filter(data => {
                    return !this.form.datasComAgendamento.ambulatorio
                        .filter(dataComAgendamentoAmbulatorio => dataComAgendamentoAmbulatorio.especialidadeId === this.model.especialidadeId)
                        .find(dataComAgendamentoAmbulatorio => dataComAgendamentoAmbulatorio.data === data.data)
                })
            }

            data = data.find(data => this.others.moment(data.data, 'DD/MM/YYYY').isSame(value.date))

            if (data) {
                if (value.date >= this.others.moment(this.additionals.dataAtual, 'DD/MM/YYYY')) {
                    const datasComAgendamentoAmbulatorio = this.form.datasComAgendamento.ambulatorio
                        .filter(dataComAgendamentoAmbulatorio => this.others.moment(dataComAgendamentoAmbulatorio.data, 'DD/MM/YYYY').isSame(value.date))

                    const datasComAgendamentoExameImagem = this.form.datasComAgendamento.exameImagem
                        .filter(dataComAgendamentoExameImagem => this.others.moment(dataComAgendamentoExameImagem.data, 'DD/MM/YYYY').isSame(value.date))

                    const datasComAgendamentoExameLaboratorial = this.form.datasComAgendamento.exameLaboratorial
                        .filter(dataComAgendamentoExameLaboratorial => this.others.moment(dataComAgendamentoExameLaboratorial.data, 'DD/MM/YYYY').isSame(value.date))

                    if (datasComAgendamentoAmbulatorio.length > 0 || datasComAgendamentoExameImagem.length > 0 || datasComAgendamentoExameLaboratorial.length > 0) {
                        let message = 'Já existe(m) agendamento(s) para este dia: <br/><br/>'

                        if (datasComAgendamentoAmbulatorio.length > 0) {
                            let list = ''

                            datasComAgendamentoAmbulatorio.forEach(dataComAgendamentoAmbulatorio => {
                                list = list + `<li>
                                    Horário: ${dataComAgendamentoAmbulatorio.horario} (${dataComAgendamentoAmbulatorio.tipoNome}),
                                    no local de atendimento ${dataComAgendamentoAmbulatorio.infraestruturaNome},
                                    da unidade ${dataComAgendamentoAmbulatorio.unidadeNomeFantasia}
                                    para a especialidade ${dataComAgendamentoAmbulatorio.especialidadeNome}.
                                </li>`
                            })

                            message = message + `
                                Módulo: Ambulatório
                                <br/><br/>
                                <ul>${list}</ul>
                            `
                        }

                        if (datasComAgendamentoExameImagem.length > 0) {
                            let list = ''

                            datasComAgendamentoExameImagem.forEach(dataComAgendamentoExameImagem => {
                                list = `<li>
                                    Horário: ${dataComAgendamentoExameImagem.horario},
                                    no local de atendimento ${dataComAgendamentoExameImagem.infraestruturaNome},
                                    da unidade ${dataComAgendamentoExameImagem.unidadeNomeFantasia}.
                                </li>`
                            })

                            message = message + `
                                Módulo: Exame de imagem
                                <br/><br/>
                                <ul>${list}</ul>
                            `
                        }

                        if (datasComAgendamentoExameLaboratorial.length > 0) {
                            let list = ''

                            datasComAgendamentoExameLaboratorial.forEach(dataComAgendamentoExameLaboratorial => {
                                list = `<li>
                                    Horário: ${dataComAgendamentoExameLaboratorial.horario},
                                    no local de atendimento ${dataComAgendamentoExameLaboratorial.infraestruturaNome},
                                    da unidade ${dataComAgendamentoExameLaboratorial.unidadeNomeFantasia}.
                                </li>`
                            })

                            message = message + `
                                Módulo: Exame laboratorial
                                <br/><br/>
                                <ul>${list}</ul>
                            `
                        }

                        message = message + 'Deseja continuar com o agendamento?'

                        this.showConfirmation(
                            message,
                            async () => this.openModalHorario(value.date)
                        )
                    } else {
                        this.openModalHorario(value.date)
                    }
                } else {
                    this.showWarningNotification('Não é possível reagendar para datas menores que a atual.')
                }
            }
        },
        create() {
            this.setLoading()

            this.form = null
            this.model = null
            this.showCalendar = false

            this.$refs.RkmModal.show()

            this.repositories.agendamento.create(this.pacienteId, this.camelObjectKeysToSnakeRecursive({origem: 'cadastro'}))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.$nextTick().then(() => {

                        this.$refs.RkmFormCadastro.resetValidator()

                        if (this.isFromRegulacao) {

                            if (this.form.unidades.find(u => u.id === this.regulacaoSolicitacao.prestador.unidadeId)) {

                                this.model.unidadeId = this.regulacaoSolicitacao.prestador.unidadeId;

                                this.handleUnidadeChange(this.model.unidadeId)
                            }
                            else {

                                this.showWarningNotification('Não há jornada(s) para a unidade prestadora.');
                            }
                        }
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        authorizedSupervisorAgendamento() {
            this.getUnidadePaciente(this.model.infraestruturaId, this.model.especialidadeId)
        },
        canceledSupervisorAgendamento() {
            this.model.especialidadeId = null
        },
        openModalSupervisorJornada(data) {
            this.$refs.ModalSupervisorJornada.open(data)
        },
        authorizedSupervisorJornada(data) {
            this.verificaAgendamentosMesmoDia(data)
        },
        canceledSupervisorJornada() {
            this.getDatas(this.model.infraestruturaId, this.model.ocupacaoId, this.model.especialidadeId, this.model.usuarioId)
        },
        verificaAgendamentosMesmoDia(jornada) {
            const date = this.others.moment(jornada.data, 'DD/MM/YYYY')

            const datasComAgendamentoAmbulatorio = this.form.datasComAgendamento.ambulatorio
                .filter(dataComAgendamentoAmbulatorio => this.others.moment(dataComAgendamentoAmbulatorio.data, 'DD/MM/YYYY').isSame(date))

            const datasComAgendamentoExameImagem = this.form.datasComAgendamento.exameImagem
                .filter(dataComAgendamentoExameImagem => this.others.moment(dataComAgendamentoExameImagem.data, 'DD/MM/YYYY').isSame(date))

            const datasComAgendamentoExameLaboratorial = this.form.datasComAgendamento.exameLaboratorial
                .filter(dataComAgendamentoExameLaboratorial => this.others.moment(dataComAgendamentoExameLaboratorial.data, 'DD/MM/YYYY').isSame(date))

            if (datasComAgendamentoAmbulatorio.length > 0 || datasComAgendamentoExameImagem.length > 0 || datasComAgendamentoExameLaboratorial.length > 0) {
                let message = 'Já existe(m) agendamento(s) para este dia: <br/><br/>'

                if (datasComAgendamentoAmbulatorio.length > 0) {
                    let list = ''

                    datasComAgendamentoAmbulatorio.forEach(dataComAgendamentoAmbulatorio => {
                        list = list + `<li>
                            Horário: ${dataComAgendamentoAmbulatorio.horario} (${dataComAgendamentoAmbulatorio.tipoNome}),
                            no local de atendimento ${dataComAgendamentoAmbulatorio.infraestruturaNome},
                            da unidade ${dataComAgendamentoAmbulatorio.unidadeNomeFantasia}
                            para a especialidade ${dataComAgendamentoAmbulatorio.especialidadeNome}.
                        </li>`
                    })

                    message = message + `
                        Módulo: Ambulatório
                        <br/><br/>
                        <ul>${list}</ul>
                    `
                }

                if (datasComAgendamentoExameImagem.length > 0) {
                    let list = ''

                    datasComAgendamentoExameImagem.forEach(dataComAgendamentoExameImagem => {
                        list = `<li>
                            Horário: ${dataComAgendamentoExameImagem.horario},
                            no local de atendimento ${dataComAgendamentoExameImagem.infraestruturaNome},
                            da unidade ${dataComAgendamentoExameImagem.unidadeNomeFantasia}.
                        </li>`
                    })

                    message = message + `
                        Módulo: Exame de imagem
                        <br/><br/>
                        <ul>${list}</ul>
                    `
                }

                if (datasComAgendamentoExameLaboratorial.length > 0) {
                    let list = ''

                    datasComAgendamentoExameLaboratorial.forEach(dataComAgendamentoExameLaboratorial => {
                        list = `<li>
                            Horário: ${dataComAgendamentoExameLaboratorial.horario},
                            no local de atendimento ${dataComAgendamentoExameLaboratorial.infraestruturaNome},
                            da unidade ${dataComAgendamentoExameLaboratorial.unidadeNomeFantasia}.
                        </li>`
                    })

                    message = message + `
                        Módulo: Exame laboratorial
                        <br/><br/>
                        <ul>${list}</ul>
                    `
                }

                message = message + 'Deseja continuar com o agendamento?'

                this.showConfirmation(
                    message,
                    async () => {this.$nextTick().then(() => this.verificaFaltas(jornada))},
                    async () => this.getDatas(this.model.infraestruturaId, this.model.ocupacaoId, this.model.especialidadeId, this.model.usuarioId)
                )
            } else {
                this.verificaFaltas(jornada)
            }
        },
        verificaFaltas(jornada) {
            if (this.form.faltas.length > 0) {
                let message = ''

                this.form.faltas.forEach(falta => {
                    message = message + `<li>${falta.data} às ${falta.horario}, ${falta.especialidade}, ${falta.usuario}</li>`
                })

                this.showConfirmation(
                    `
                        O paciente possui ${this.form.faltas.length} falta(s) na(s) seguinte(s) data(s) e especialidade(s):
                        <br/><br/>
                        <ul>${message}</ul>
                        Deseja continuar?
                    `,
                    async () => this.store(jornada.jornadaId, jornada.horario),
                    async () => this.$refs.RkmModal.hide()
                )
            }
            else {
                this.store(jornada.jornadaId, jornada.horario)
            }
        },
        store(jornadaId, horario) {
            this.setLoading()

            const request = {
                jornadaId,
                horario,
            }

            const promise = this.agendamentoId
                ? this.repositories.agendamento.update(this.agendamentoId, this.camelObjectKeysToSnakeRecursive(request))
                : this.repositories.agendamento.store(this.camelObjectKeysToSnakeRecursive({
                    pacienteId: this.pacienteId,
                    ...request,
                    regulacaoSolicitacaoId: this.regulacaoSolicitacao?.id ?? null,
                }))

            promise
                .then(response => {
                    this.print(response.data.id)
                    this.handleSaved(response.data)
                    this.showSaveNotification()
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.showWarningNotification(error.response.data.message)
                        this.isButtonVisible = true
                        return
                    }
                    this.handleError(error)
                })
                .finally(() => this.unsetLoading())
        },
        print(id) {
            this.setLoading()

            this.repositories.impressao.agendamento(id)
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        edit(id) {
            this.setLoading()

            this.agendamentoId = id

            this.additionals = null
            this.form = null
            this.model = null
            this.showCalendar = false

            this.$refs.RkmModal.show()

            this.repositories.agendamento.edit(id)
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                    this.$set(this.form, 'datasComSituacao', response.data.form.situacao)
                    this.showCalendar = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        openModalHorario(date) {
            this.$refs.ModalHorario.open(
                this.model.infraestruturaId,
                this.model.ocupacaoId,
                this.model.especialidadeId,
                this.model.usuarioId,
                this.others.moment(date).format('DD/MM/YYYY'),
                this.agendamentoId
            )
        },
        handleSaved(data) {

            if (this.isFromRegulacao || this.closeOnSave) {

                this.$emit('save', data)
                this.$refs.RkmModal.hide()
            }
            else {

                this.hide()
            }
        },
        hide() {
            const especialidade = this.form.especialidades.find(especialidade => especialidade.id === this.model.especialidadeId)

            if (especialidade.tratamento === false) {
                this.$refs.RkmModal.hide()

                if (this.agendamentoId) {
                    this.$emit('updated')
                }
            } else {
                this.getDatas(this.model.infraestruturaId, this.model.ocupacaoId, this.model.especialidadeId, this.model.usuarioId)
            }
        },
        async getInfraestruturas(unidadeId) {
            const request = {
                origem: 'cadastro',
                listar: 'infraestruturas',
                pacienteId: this.pacienteId,
                unidadeId,
                agendamentoId: this.agendamentoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.infraestruturas = Object.assign(response.data.infraestruturas)

                if (this.isFromRegulacao) {

                    if (this.form.infraestruturas.find(i => i.id === this.regulacaoSolicitacao.prestador.infraestruturaId)) {

                        this.model.infraestruturaId = this.regulacaoSolicitacao.prestador.infraestruturaId;

                        this.getOcupacoes(this.model.infraestruturaId)
                    }
                    else {

                        this.showWarningNotification('Não há jornada(s) para o local de atendimento prestador.');
                    }
                }
                else if (this.form.infraestruturas.length === 1) {
                    const selected = this.form.infraestruturas[0]
                    this.model.infraestruturaId = selected.id

                    this.getOcupacoes(this.model.infraestruturaId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getOcupacoes(infraestruturaId) {
            const request = {
                origem: 'cadastro',
                listar: 'ocupacoes',
                pacienteId: this.pacienteId,
                infraestruturaId,
                agendamentoId: this.agendamentoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.ocupacoes = Object.assign(response.data.ocupacoes)

                if (this.isFromRegulacao) {

                    if (this.form.ocupacoes.find(o => o.id === this.regulacaoSolicitacao.itens[0].especialidade.ocupacaoId)) {

                        this.model.ocupacaoId = this.regulacaoSolicitacao.itens[0].especialidade.ocupacaoId;

                        this.getEspecialidades(infraestruturaId, this.model.ocupacaoId)
                    }
                    else {

                        this.showWarningNotification('Não há jornada(s) para a ocupação regulada.');
                    }
                }
                else if (this.form.ocupacoes.length === 1) {
                    const selected = this.form.ocupacoes[0]
                    this.model.ocupacaoId = selected.id

                    this.getEspecialidades(infraestruturaId, this.model.ocupacaoId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getEspecialidades(infraestruturaId, ocupacaoId) {
            const request = {
                origem: 'cadastro',
                listar: 'especialidades',
                pacienteId: this.pacienteId,
                infraestruturaId,
                ocupacaoId,
                agendamentoId: this.agendamentoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.especialidades = Object.assign(response.data.especialidades)

                if (this.isFromRegulacao) {

                    const selected = this.form.especialidades.find(e => e.id === this.regulacaoSolicitacao.itens[0].especialidade.id)

                    if (selected) {

                        this.model.especialidadeId = this.regulacaoSolicitacao.itens[0].especialidade.id

                        if (selected.tratamento === false) {
                            this.getAgendamentos(this.model.especialidadeId)
                        } else {
                            this.getUnidadePaciente(infraestruturaId, this.model.especialidadeId)
                        }
                    }
                    else {

                        this.showWarningNotification('Não há jornada(s) para a especialidade regulada.');
                    }
                }
                else if (this.form.especialidades.length === 1) {

                   if (this.form.especialidades[0].isRegulado == true) {

                        let message = 'A especialidade selecionada é regulada, para prosseguir é necessário a senha de um supervisor. Deseja continuar?'
                        const selected = this.form.especialidades[0]
                        this.model.especialidadeId = selected.id

                        this.showConfirmation(
                            message,
                            async () => {

                                await this.$nextTick()
                                this.$refs.ModalSupervisorAgendamento.open({ infraestruturaId: this.model.infraestruturaId, lotacaoInfraestruturaId: this.getLotacao().infraestruturaId })
                            },
                            async () => {
                                this.model.especialidadeId = null
                            }
                        )
                        return
                    }

                    const selected = this.form.especialidades[0]
                    this.model.especialidadeId = selected.id

                    if (selected.tratamento === false) {
                        this.getAgendamentos(this.model.especialidadeId)
                    } else {
                        this.getUnidadePaciente(infraestruturaId, this.model.especialidadeId)
                    }
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getUnidadePaciente(infraestruturaId, especialidadeId) {
            this.setLoading()

            try {
                const {data} = await this.repositories.agendamento.unidadePaciente(this.pacienteId, infraestruturaId)

                if (data.unidadeComJornada) {
                    this.showConfirmation(
                        `Paciente pertence à unidade ${data.unidade}, deseja continuar com o agendamento?`,
                        async () => this.getUsuarios(infraestruturaId, this.model.ocupacaoId, especialidadeId),
                        async () => this.model.especialidadeId = null
                    )
                } else {
                    this.getUsuarios(infraestruturaId, this.model.ocupacaoId, especialidadeId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        getAgendamentos(especialidadeId) {
            this.setLoading()

            try {
                let datasComAgendamentoAmbulatorio = this.form.datasComAgendamento.ambulatorio
                    .filter(dataComAgendamentoAmbulatorio => dataComAgendamentoAmbulatorio.especialidadeId === especialidadeId)

                if (this.agendamentoId) {
                    datasComAgendamentoAmbulatorio = datasComAgendamentoAmbulatorio
                        .filter(dataComAgendamentoAmbulatorio => dataComAgendamentoAmbulatorio.id !== this.agendamentoId)
                }

                if (datasComAgendamentoAmbulatorio.length > 0) {
                    let message = 'Já existe(m) agendamento(s) para esta especialidade:'
                    let list = ''

                    datasComAgendamentoAmbulatorio.forEach(dataComAgendamentoAmbulatorio => {
                        list = list + `<li>
                            Dia: ${dataComAgendamentoAmbulatorio.data} às ${dataComAgendamentoAmbulatorio.horario} (${dataComAgendamentoAmbulatorio.tipoNome}),
                            no local de atendimento ${dataComAgendamentoAmbulatorio.infraestruturaNome},
                            da unidade ${dataComAgendamentoAmbulatorio.unidadeNomeFantasia}.
                        </li>`
                    })

                    message = message + `
                        <br/><br/>
                        <ul>${list}</ul>
                        Deseja continuar com o agendamento?
                    `

                    this.showConfirmation(
                        message,
                        async () => {

                            this.$refs.ModalSupervisorAgendamento.open({ infraestruturaId: this.model.infraestruturaId, lotacaoInfraestruturaId: this.getLotacao().infraestruturaId })
                        },
                        async () => this.model.especialidadeId = null
                    )
                } else {
                    this.getUnidadePaciente(this.model.infraestruturaId, especialidadeId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getUsuarios(infraestruturaId, ocupacaoId, especialidadeId) {
            const request = {
                origem: 'cadastro',
                listar: 'usuarios',
                pacienteId: this.pacienteId,
                infraestruturaId,
                ocupacaoId,
                especialidadeId,
                agendamentoId: this.agendamentoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.usuarios = Object.assign(response.data.usuarios)
                this.form.faltas = Object.assign(response.data.faltas)

                if (this.form.usuarios.length === 1) {
                    const selected = this.form.usuarios[0]
                    this.model.usuarioId = selected.id

                    this.getSugestao(infraestruturaId, ocupacaoId, especialidadeId, this.model.usuarioId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getSugestao(infraestruturaId, ocupacaoId, especialidadeId, usuarioId) {
            this.setLoading()

            try {
                const {data} = await this.repositories.agendamento.sugestao(this.pacienteId, infraestruturaId, ocupacaoId, especialidadeId, usuarioId)

                if (data.jornadaId) {
                    let message = ''

                    if (this.regulacaoSolicitacao && this.regulacaoSolicitacao.numero) {
                        message = message + `Protocolo de fechamento: <strong>${this.regulacaoSolicitacao.numero}</strong><br/><br/>`
                    }

                    data.infraestruturaId = this.model.infraestruturaId
                    data.lotacaoInfraestruturaId = this.getLotacao().infraestruturaId
                    message = message + `A próxima data disponível para o agendamento de <strong>${data.tipoNome}</strong> é <strong>${data.data} (${data.diaSemana}) às ${data.horario}</strong>. Deseja continuar?`

                    this.showConfirmation(
                        message,
                        async () => {this.$nextTick().then(() => data.obrigatorioAutenticacaoSupervisor ? this.openModalSupervisorJornada(data) : this.verificaAgendamentosMesmoDia(data))},
                        async () => this.getDatas(infraestruturaId, ocupacaoId, especialidadeId, usuarioId)
                    )
                } else {
                    this.getDatas(infraestruturaId, ocupacaoId, especialidadeId, usuarioId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getDatas(infraestruturaId, ocupacaoId, especialidadeId, usuarioId) {
            const request = {
                origem: 'cadastro',
                listar: 'datas',
                pacienteId: this.pacienteId,
                infraestruturaId,
                ocupacaoId,
                especialidadeId,
                usuarioId,
                agendamentoId: this.agendamentoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.datasBloqueadas = Object.assign(response.data.datasBloqueadas)
                this.form.datasComAgendamento = Object.assign(response.data.datasComAgendamento)
                this.form.datas = Object.assign(response.data.datas)
                this.$set(this.form, 'datasComSituacao', response.data.situacao)

                this.showCalendar = true
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
    },
    mixins: [error, file, repository, stringCase],
    props: {
        closeOnSave: {type: Boolean},
        disableFilters: {type: Boolean, default: false},
        pacienteId: {type: [Number, String], required: true},
        regulacaoSolicitacao: {type: Object},
    },
}
</script>